import { locales } from "@/lib/shared/constants";

const externalHrefPattern = /^(?:[a-z][a-z\d+.-]*:|\/\/|#)/i;

export type HeroLink = {
  href: string;
  locale?: string;
};

export function normalizeHeroLink(href: string | null | undefined): HeroLink | null {
  const value = href?.trim();
  if (!value) return null;
  if (externalHrefPattern.test(value)) return { href: value };

  const path = value.startsWith("/") ? value : `/${value}`;
  const explicitLocale = locales.find(
    (locale) => path === `/${locale}` || path.startsWith(`/${locale}/`),
  );

  if (!explicitLocale) return { href: path };

  return {
    href: path.slice(explicitLocale.length + 1) || "/",
    locale: explicitLocale,
  };
}

export function getHeroImageAlt(
  alt: string | null | undefined,
  title: string,
  label: string,
): string {
  const value = alt?.trim();
  if (value && !/^(?:banner|hero|image)$/i.test(value)) return value;
  return [title, label].filter(Boolean).join(" - ");
}

export function getCategoryImageAlt(alt: string | null | undefined, categoryLabel: string): string {
  const value = alt?.trim();
  const normalizedValue = value?.toLocaleLowerCase();
  const normalizedCategoryLabel = categoryLabel.trim().toLocaleLowerCase();
  if (
    value &&
    normalizedValue !== normalizedCategoryLabel &&
    !/^(?:banner|category|hero|image)$/i.test(value)
  ) {
    return value;
  }
  return `${categoryLabel} jewellery collection`;
}
